import {
  computed,
  Component,
  input,
  output,
  ChangeDetectionStrategy,
  linkedSignal
} from '@angular/core';
import { NameValue } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {
  ImmomioRadioGroupComponent,
  type RadioItem
} from '@immomio/ui/radio-group';
import { AppInputDirective } from '../../form/controls/input/input.directive';
import { FormFieldLabelComponent } from '../../form/form-field/form-field-label/form-field-label.component';
import { FormFieldComponent } from '../../form/form-field/form-field.component';

@Component({
  selector: 'app-confirm-reason',
  templateUrl: './confirm-reason.component.html',
  styleUrls: ['./confirm-reason.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioRadioGroupComponent,
    FormsModule,
    FormFieldComponent,
    FormFieldLabelComponent,
    AppInputDirective,
    TranslatePipe
  ]
})
export class ConfirmReasonComponent {
  // The v22 model-output migration split these `model()`s into an input plus a
  // linkedSignal, because their implicit `*Change` outputs collided with the
  // explicit `output()`s below. The aliases keep the public binding names, so
  // no-input-rename is expected here.
  /* eslint-disable @angular-eslint/no-input-rename */
  readonly reasonTypeModelInput = input<string>(undefined, {
    alias: 'reasonTypeModel'
  });
  readonly reasonTypeModel = linkedSignal(this.reasonTypeModelInput);

  readonly otherReasonTextInput = input<string>(undefined, {
    alias: 'otherReasonText'
  });
  readonly otherReasonText = linkedSignal(this.otherReasonTextInput);
  /* eslint-enable @angular-eslint/no-input-rename */
  readonly reasons = input<NameValue[]>(undefined);
  protected readonly reasonItems = computed<RadioItem[]>(() =>
    (this.reasons() ?? []).map(({ name, value }) => ({ label: name, value }))
  );

  readonly reasonTypeModelChange = output<string>();
  readonly otherReasonTextChange = output<string>();

  public get showText() {
    return this.reasonTypeModel() === 'OTHER_REASON';
  }

  public onReasonTypeModelChange(value: string) {
    this.reasonTypeModelChange.emit(value);
  }

  public onOtherReasonTextChange(value: string) {
    this.otherReasonTextChange.emit(value);
  }
}
